import { Vue, MsgBox } from '../../app.vues';
import { Utils } from '../../app.base';

import SwbStaffEnrollFromAudit from './StaffEnrollFromAudit'
Vue.regist(SwbStaffEnrollFromAudit);

import SwbRetailerComRoleForSelect from './RetailerComRoleForSelect'
Vue.regist(SwbRetailerComRoleForSelect);
// 当个机构
export function openRetailerComRoleDlg(bizUnitId, comId, callback) {
    let self = this;
    let theDlg = Vue.$showDialog({
        title: '岗位选择',
        width: 1100,
        height: 750,
        template: '<div class = "">' +
        '<swb-retailer-com-role-select :bizUnitId="bizUnitId" :comId="comId" ref="swb_retailer_com_role_select"></swb-retailer-com-role-select>' +
        '</div>',
        data: {
            bizUnitId: bizUnitId,
            comId: comId
        },
        okClicked: function () {
            let resultData = this.$refs.swb_retailer_com_role_select.getDlgResult() || {};
            if(resultData.type === 'info') {
                callback(resultData.data)
            } else {
                MsgBox.warning(resultData.message);
                return false;
            }
        }
    });
}

export function openStaffEnrollFormAuditDlg(row, callback) {
    //
    let self = this;
    let theDlg = Vue.$showDialog({
        title: '审核',
        width: 800,
        height: 600,
        template: '<div class = "">' +
        '<swb-staff-enroll-from-audit :row="row" ref="swb_staff_enroll_from_audit"></swb-staff-enroll-from-audit>' +
        '</div>',
        data: {
            row: row
        },
        okClicked: function () {
            let resultData = this.$refs.swb_staff_enroll_from_audit.getDlgResult() || {};
            if(resultData.type === 'info') {
                callback(resultData.data)
            } else {
                MsgBox.warning(resultData.message);
                return false;
            }
        }
    });
}



//////////////////
// WEBPACK FOOTER
// ./src/compo/staffBiz/selectDlg.js
// module id = 366
// module chunks = 0